import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    window.dispatchEvent(new CustomEvent('wizard-widget:toggle'));
  }
}
